import { http } from '../http'
import type { CurrentUser } from '@/stores/auth'

export const meApi = {
  async get(): Promise<CurrentUser> {
    const { data } = await http.get<CurrentUser>('/me')
    return data
  },
  async changePassword(current_password: string, new_password: string): Promise<void> {
    await http.post('/me/password', { current_password, new_password })
  },
  async mfaSetup(): Promise<{ secret: string; otpauth_uri: string }> {
    const { data } = await http.post<{ secret: string; otpauth_uri: string }>('/me/mfa/setup')
    return data
  },
  async mfaEnable(code: string): Promise<{ recovery_codes: string[] }> {
    const { data } = await http.post<{ recovery_codes: string[] }>('/me/mfa/enable', { code })
    return data
  },
  async mfaDisable(code: string): Promise<void> {
    await http.post('/me/mfa/disable', { code })
  },
}
